import { TransferType } from "types/business/TransferType";
import { BehaviorSubject } from "types/libReplace/BehaviorSubject";
import { createUseDefaultObservable } from "utils/libExtend/createUseDefaultObservable";

type CurrentType = TransferType[];

export const useDefaultObservableTransferTypeArray = createUseDefaultObservable<CurrentType>();

export class BehaviorSubjectTransferTypeArray extends BehaviorSubject<CurrentType> {}
